const ServerErrorMessage = ({ children }: { children: string }) => (
  <div className="p-3 text-white bg-red-500" data-testid="server-error-message">
    {children}
  </div>
)

export default ServerErrorMessage
